import { Button, Card } from '@cimpress/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactElement } from 'react';
import { DoubleProcessedFileNamePattern, FileNamePattern } from '../../clients/dto/VLRATypes';
import { makeFieldLayout } from './util/helpers';
import { TestData } from './util/types';

export function StaticPatternDisplay({onTestSelected, pattern} : {pattern: FileNamePattern | DoubleProcessedFileNamePattern, onTestSelected: (testData: TestData) => void}): ReactElement {
  const isDoubleProcessedPattern = 'backProcessingRequiredExpression' in pattern;
  const doubleProcessedPattern = pattern as DoubleProcessedFileNamePattern;

  return (<Card className='ms-3 mb-2' header={pattern.description}>
    {makeFieldLayout('Regex', <code>{pattern.pattern}</code>)}
    {isDoubleProcessedPattern && <>
      {makeFieldLayout('Back Processing Required Expression', <code>{doubleProcessedPattern.backProcessingRequiredExpression}</code>)}
      {makeFieldLayout('Double Processing Event Types', <>{doubleProcessedPattern.doubleProcessingEventTypes.join(', ')}</>)}
    </>}
    {makeFieldLayout('Examples', <>{pattern.examples.map(example => <p key={example}>{example} <Button variant='link' onClick={() => onTestSelected({filename: example})}>Test <FontAwesomeIcon icon="arrow-alt-circle-down" /></Button></p>)}</>)}
    {pattern.excludedFulfillers ? makeFieldLayout(<>Excluded Fulfillers <FontAwesomeIcon color='red' icon={'ban'}/></>, <>{pattern.excludedFulfillers.join(', ')}</>) : <></>}
  </Card>);
}